import { createAction, props } from '@ngrx/store';
import { CertifyRole } from 'src/app/pages/certify-dashboard/domain/enums/certify-role.enum';
import { IUserRoles } from './user-roles.models';

export const loadUserRoles = createAction('[UserRoles] Load');

export const loadUserRolesSuccess = createAction(
  '[UserRoles] Load Success',
  props<{ userGuid: string; roles: IUserRoles[] }>(),
);

export const loadUserRolesFailure = createAction('[UserRoles] Load Failure', props<{ error: string }>());

export const setCurrentCertifyRole = createAction(
  '[UserRoles] Set Current Certify Role',
  props<{ role: CertifyRole | undefined }>(),
);

export const loadingUserRoles = createAction('[UserRoles] Loading', props<{ loading: boolean }>());

export const resetUserRoles = createAction('[UserRoles] Reset');
export const refreshUserRoles = createAction('[UserRoles] Refresh');
